var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inputValue.length > 0)?_c('div',{staticClass:"simple-accordion"},_vm._l((_vm.inputValue),function(optionGroup,i){return _c('OptionGroup',{key:i,on:{"itemClick":_vm.itemClick},model:{value:(_vm.inputValue[i]),callback:function ($$v) {_vm.$set(_vm.inputValue, i, $$v)},expression:"inputValue[i]"}})}),1):_c('div',{staticStyle:{"padding":"20px"}},[_vm._v("\n  "+_vm._s(_vm.$t('optionbox.no-selected'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3188b5f3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/options/OptionBox.vue
// module id = 102
// module chunks = 0 1